import React from 'react';
import './TokenExpiredModal.css';

const TokenExpiredModal = ({ show, onLogin }) => {
  if (!show) return null;

  return (
    <div className="token-modal-overlay">
      <div className="token-modal">
        <div className="token-modal-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#ff6b6b"/>
          </svg>
        </div>
        
        <div className="token-modal-content">
          <h2>Session Expired</h2>
          <p>Your session has expired or is invalid. Please login again to continue using the application.</p>
        </div>
        
        <div className="token-modal-actions">
          <button className="token-login-btn" onClick={onLogin}>
            Login Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenExpiredModal;